// src/utils/fetchInterceptor.js
import router from '@/router'
import { ElMessageBox } from 'element-plus' // 根据你的 UI 库调整

// 保存原始的 fetch

const originalFetch = window.fetch


class AuthInterceptor {

  constructor() {
    this.isRefreshing = false
    this.retryQueue = []
  }

  start() {
    window.fetch = this.interceptedFetch.bind(this)
  }

  async interceptedFetch(input, init = {}) {
    let response = await originalFetch(input, init)

    // 克隆响应以便读取
    const clonedResponse = response.clone()

    try {
      const data = await clonedResponse.json()


      // 检查登录超时
      if (data.status === -1 && data.msg.includes('登陆超时')) {

        this.handleSessionTimeout()
        return response // 返回原始响应，让业务代码也能收到
      }

    } catch (error) {
      // 响应不是 JSON 格式，忽略
    }

    return response
  }

  async handleSessionTimeout() {
    // 防止重复处理
    console.log("处理超时")
    if (this.isHandlingTimeout) {
      return
    }
    this.isHandlingTimeout = true
    // ... existing code ...
    this.num = 5
    this.windowisClosed = false
    ElMessageBox({
      title: '提示',
      message: `<span id="timeout-count">登录已过期，请重新登录，${this.num}秒后自动跳转至登录页面,您也可以直接点击确定跳到登录页面!</span>`,
      type: 'error',
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      dangerouslyUseHTMLString: true
    }).finally(() => {
      this.windowisClosed = true
    })

    while (this.num > 0 && !this.windowisClosed) {
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.num--
      const el = document.getElementById('timeout-count')
      if (el) {
        el.innerText = `登录已过期，请重新登录，${this.num}秒后自动跳转至登录页面,您也可以直接点击确定跳到登录页面!`
      }
    }

    router.push('/login')
    ElMessageBox.close()
    this.isHandlingTimeout = false
    // ... existing code ...



  }

  clearUserInfo() {
    // 清除本地存储的 token 等信息
    localStorage.removeItem('userInfo')

    // 如果使用 Vuex，清除用户状态
    // store.commit('user/CLEAR_USER_INFO')
  }
}

export const authInterceptor = new AuthInterceptor()